import React from 'react'
import { usePermission } from '@tomfxs/permissions-client'

import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import RouteContainer from 'src/components/App/RouteContainer'

const EventPlanningCalendar = React.lazy(() => loadComponent('traiwiss', 'EventPlanningCalendar'))

export function EventPlanningCalendarRoute() {
    const { academy } = useFlightDeck()

    const canCreate = usePermission('traiwiss.event.create', { academy: academy?._id! })
    const canUpdate = usePermission('traiwiss.event.update', { academy: academy?._id! })
    const canDelete = usePermission('traiwiss.event.delete', { academy: academy?._id! })

    return (
        <RouteContainer>
            <EventPlanningCalendar academyId={academy?._id} canCreate={canCreate} canUpdate={canUpdate} canDelete={canDelete} />
        </RouteContainer>
    )
}
